<ng-container *ngIf="ready == false">
    <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>
<ng-container *ngIf="ready">
    <mat-card appearance="outlined">
        <div class="flex-container">
            <div class="ms-3" class="second-column">
                <p>
                    <strong>Listado de gastos</strong>
                </p>
                <div class="text-end">
                    <button class="ms-3" mat-stroked-button (click)="closeDialog()">
                        <mat-icon>close</mat-icon>
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    </mat-card>
    <app-table [columns]="headerTable" [dataSource]="dataSource" [actionsTemplate]="actionsButtons"
        [hasHeaderActions]="true" [hasButton]="true" [headerActionsTemplate]="headerActionsButtons">
    </app-table>

    <ng-template #actionsButtons let-uid="uid">
        <ng-container *ngFor="let row of (dataSource | filter : uid : 'uid'); trackBy: trackByIndex">
            <ul class="custom-class">
                <li (click)="assign(row.uid, row.invoiceNumber)">
                    <a>
                        <mat-icon>payment</mat-icon>Asignar pago
                    </a>
                </li>
            </ul>
        </ng-container>
    </ng-template>
    <br />
</ng-container>
